import React from "react";
import { CircleBadge, IconButton, Popover, Tooltip } from "@commonsku/design-system";
import { LuListChecks } from "react-icons/lu";
import styled from "styled-components";
import { TASKS_DISPLAY_LIMIT } from "../../../redux/myTasks";

const TasksCircleBadge = styled(CircleBadge)`
  z-index: 1;
`;

export interface TasksMenuTriggerProps {
  triggerId: string;
  myTasksNewCount: number;
  assignedTasksNewCount: number;
}

/** The nav bar icon button that opens the tasks popover, with its tooltip. */
const TasksMenuTrigger = ({ triggerId, myTasksNewCount, assignedTasksNewCount }: TasksMenuTriggerProps) => {
  const count = Math.min(myTasksNewCount, TASKS_DISPLAY_LIMIT) + Math.min(assignedTasksNewCount, TASKS_DISPLAY_LIMIT);
  const hasMore = myTasksNewCount >= TASKS_DISPLAY_LIMIT || assignedTasksNewCount >= TASKS_DISPLAY_LIMIT;

  return (
    <Tooltip.Root ids={{ trigger: triggerId }} positioning={{ placement: "bottom-end", strategy: "fixed" }}>
      <Tooltip.Trigger asChild>
        <Popover.Trigger asChild>
          <TasksCircleBadge count={hasMore ? `${count}+` : count} color="brand" size="small">
            <IconButton label="Tasks" size="sm" variant="outline" colorPalette="neutral" rounded="md">
              <LuListChecks />
            </IconButton>
          </TasksCircleBadge>
        </Popover.Trigger>
      </Tooltip.Trigger>
      <Tooltip.Positioner>
        <Tooltip.Content>Tasks</Tooltip.Content>
      </Tooltip.Positioner>
    </Tooltip.Root>
  );
};

export default TasksMenuTrigger;
